import { useSearchParams } from 'next/navigation';
import GameLandingScreen from './GameLandingScreen';
import { useEffect } from 'react';
import { useAppStore } from '../../hooks/useAppStore';
import { fetchWatchAndWinConfig } from '../../services/apiRequests/WatchAndWinService';
import QuizScreen from './QuizScreen';
import { GamificationScreens } from '../../store/interface';
import { useGamificationUserStatus } from '../../hooks/useGamificationUserStatus';
import UserDetailsPopup from '../userDetailsPopup/UserDetailsPopup';
import {
  parseGameMapperId,
  triggerQuizLandingPageEvent
} from '../../utils/watchAndWinUtils';
import ContestsAndWinners from './contestAndWinners/ContestAndWinners';
import { getLocalStorage } from '../../utils/browserStorageHandler';
import { PLAY_GAMIFICATION_CTA_CLICKED } from '../../utils/constants/localStorageConstants';

const WatchAndWinPage = () => {
  const searchParams = useSearchParams();
  const gameMapperId = parseGameMapperId(
    searchParams.get('game_mapper_id') || ''
  );
  const {
    getStartedHandler,
    isUserOnBoarded,
    showUserDetailsPopup,
    setIsUserOnBoarded
  } = useGamificationUserStatus(gameMapperId as string);

  const {
    gamificationState = {},
    isUserLoggedIn,
    usersData,
    setGamificationState,
    usersLocationData
  } = useAppStore();
  const { currentScreen } = gamificationState;

  const setWatchAndWinConfig = async () => {
    const config = await fetchWatchAndWinConfig(gameMapperId as string);
    setGamificationState({
      config: config
    });
  };

  useEffect(() => {
    setWatchAndWinConfig();
    triggerQuizLandingPageEvent(gameMapperId as string);
  }, []);

  useEffect(() => {
    if (
      isUserLoggedIn &&
      currentScreen === GamificationScreens.Quiz &&
      usersData?.email
    ) {
      getStartedHandler(usersData, usersLocationData);
    }
  }, [
    isUserLoggedIn,
    isUserOnBoarded,
    currentScreen,
    usersData,
    usersLocationData
  ]);

  useEffect(() => {
    const isPlayGamificationCtaClicked = getLocalStorage(
      PLAY_GAMIFICATION_CTA_CLICKED
    );
    if (
      isUserLoggedIn &&
      usersData?.email &&
      isPlayGamificationCtaClicked &&
      isPlayGamificationCtaClicked == 'true' &&
      !currentScreen
    ) {
      setGamificationState({ currentScreen: GamificationScreens.Quiz });
    }
  }, [isUserLoggedIn, usersData, currentScreen]);

  if (isUserLoggedIn && showUserDetailsPopup) {
    return (
      <UserDetailsPopup
        setIsUserOnBoarded={setIsUserOnBoarded}
        gameMapperId={gameMapperId as string}
      />
    );
  }

  switch (currentScreen) {
    case GamificationScreens.Landing: {
      return <GameLandingScreen isUserOnBoarded={isUserOnBoarded} />;
    }
    case GamificationScreens.Quiz:
    case GamificationScreens.Result: {
      return <QuizScreen />;
    }
    case GamificationScreens.Winners: {
      return <ContestsAndWinners />;
    }
  }

  return <GameLandingScreen isUserOnBoarded={isUserOnBoarded} />;
};

export default WatchAndWinPage;
